import { FC, SVGAttributes } from 'react';

type CoconutSvgProps = SVGAttributes<SVGElement>;

export const CoconutSvg: FC<CoconutSvgProps> = (props) => {
    return (
        <svg
            width="57"
            height="56"
            viewBox="0 0 57 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46.2274 15.2857C46.5927 16.4236 46.7308 17.6845 47.3267 18.7205C51.7261 26.3681 50.3434 36.6693 43.3856 43.6271C33.4704 53.5424 22.2978 52.2851 14.6314 44.6186C6.96492 36.9522 5.95553 25.5318 15.6229 15.8644C22.5807 8.90659 32.8819 7.52394 40.5295 11.9233C41.5654 12.5192 42.8264 12.6572 43.9643 13.0225C44.4779 13.1874 44.961 13.4737 45.3686 13.8813C45.7763 14.289 46.0626 14.7721 46.2274 15.2857Z"
                fill="#7E3D23"
            />
            <g style={{ mixBlendMode: 'multiply' }}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.7147 37.7247C23.8216 38.6178 22.3735 38.6178 21.4804 37.7247C20.5872 36.8315 20.5872 35.3835 21.4804 34.4903C22.3735 33.5972 23.8216 33.5972 24.7147 34.4903C25.6078 35.3835 25.6078 36.8315 24.7147 37.7247ZM18.0585 39.3917C17.2381 39.8654 15.9331 39.1409 15.1436 37.7736C14.3542 36.4062 14.3793 34.9138 15.1997 34.4401C16.0201 33.9665 17.3251 34.691 18.1146 36.0583C18.904 37.4256 18.8789 38.9181 18.0585 39.3917ZM21.4312 44.0614C22.7985 44.8508 24.2909 44.8257 24.7646 44.0053C25.2382 43.1849 24.5138 41.8799 23.1464 41.0905C21.7791 40.301 20.2867 40.3261 19.813 41.1465C19.3393 41.9669 20.0638 43.272 21.4312 44.0614Z"
                    fill="#7E3D23"
                />
            </g>
        </svg>
    );
};
